import { buildUrl, filterEmpty, getSearchParam } from ".";
import { getLangMap } from "@/utils/getLangMap.ts";
export function cleanHash(hash: string) {
  let result = hash.split("?")[0];
  if (result.match(/\/\d+$/)) {
    result = result.replace(/\/\d+$/, "");
  }
  return result;
}
export default function sendLog1(action: any = "") {
  const channel = getSearchParam("channel");
  const params = filterEmpty({
    action: action,
    ch: channel,
    lan: getLangMap(),
    page: cleanHash(window.location.hash.substring(2)),
  });
  const url = buildUrl(import.meta.env.VITE_LOG_URL1, params);
  fetch(url, { method: "GET" });
}
